// extracted by mini-css-extract-plugin
module.exports = {"without-expiration-date":"_2s_SZGg","withoutExpirationDate":"_2s_SZGg"};